const AppConfig = {
  // Nombre d'éléments à garder dans le localstorage après une sélection
  LIMIT_SIZE_AUTOCOMPLETION_TO_SAVE: 4,
}

export default AppConfig
